import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

var PIE_COLORS = ["#3B82F6", "#F26A4B", "#10B981", "#F59E0B", "#8B5CF6", "#EC4899"];

export function FunnelBarChart({ data }) {
  return (
    <div style={{ width: "100%", height: 280 }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="name" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} />
          <Tooltip formatter={function(v) { return [v, "Leads"]; }} />
          <Bar dataKey="count" radius={[6, 6, 0, 0]}>
            {data.map(function(entry, i) {
              return <Cell key={i} fill={entry.fill} />;
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function ProductPie({ data }) {
  if (!data || data.length === 0) return <p className="text-sm text-gray-400 text-center py-10">Sem dados</p>;
  return (
    <div style={{ width: "100%", height: 220 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie data={data} cx="50%" cy="50%" innerRadius={50} outerRadius={85} paddingAngle={3} dataKey="value"
            label={function(e) { return e.name + " (" + e.value + ")"; }} labelLine={false}>
            {data.map(function(_, i) { return <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} />; })}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export function MonthlyTrendChart({ data }) {
  if (!data || data.length === 0) return null;
  return (
    <div style={{ width: "100%", height: 250 }}>
      <ResponsiveContainer>
        <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="name" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} />
          <Tooltip />
          <Bar dataKey="novos" name="Novos" fill="#3B82F6" radius={[4, 4, 0, 0]} />
          <Bar dataKey="fechados" name="Fechados" fill="#10B981" radius={[4, 4, 0, 0]} />
          <Bar dataKey="perdidos" name="Perdidos" fill="#EF4444" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function BrokerRankingTable({ ranking }) {
  if (!ranking || ranking.length === 0) return null;
  var maxFechados = ranking[0]?.fechados || 1;

  function formatCurrency(v) {
    if (!v) return "R$ 0";
    return "R$ " + Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 0 });
  }

  var rows = ranking.map(function(b, i) {
    var barWidth = Math.max(8, Math.round((b.fechados / maxFechados) * 100));
    var medalCls = i === 0 ? "bg-amber-100 text-amber-700" : i === 1 ? "bg-gray-200 text-gray-600" : i === 2 ? "bg-orange-100 text-orange-700" : "bg-gray-100 text-gray-500";
    var convCls = b.conversion_rate >= 50 ? "bg-emerald-100 text-emerald-700" : b.conversion_rate >= 25 ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700";
    return (
      <tr key={b.broker_id} className="border-b border-gray-50 hover:bg-gray-50/50" data-testid={"broker-rank-" + i}>
        <td className="py-3 px-3"><span className={"w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold " + medalCls}>{i + 1}</span></td>
        <td className="py-3 px-3">
          <p className="font-medium text-[#0A2F3D]">{b.broker_name || "Sem nome"}</p>
          <div className="mt-1 h-1.5 bg-gray-100 rounded-full overflow-hidden w-24"><div className="h-full bg-emerald-500 rounded-full" style={{ width: barWidth + "%" }} /></div>
        </td>
        <td className="py-3 px-3 text-center text-gray-600">{b.total}</td>
        <td className="py-3 px-3 text-center font-semibold text-emerald-600">{b.fechados}</td>
        <td className="py-3 px-3 text-center text-red-500">{b.perdidos}</td>
        <td className="py-3 px-3 text-center"><span className={"px-2 py-0.5 text-xs font-medium rounded-full " + convCls}>{b.conversion_rate}%</span></td>
        <td className="py-3 px-3 text-right font-medium text-[#0A2F3D]">{formatCurrency(b.total_value)}</td>
      </tr>
    );
  });

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-100 bg-gray-50/50">
            <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">#</th>
            <th className="text-left py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Corretor</th>
            <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Total</th>
            <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Fechados</th>
            <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Perdidos</th>
            <th className="text-center py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Conversao</th>
            <th className="text-right py-2.5 px-3 text-xs font-medium text-gray-500 uppercase">Valor Fechado</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}
